import { Fragment } from 'react'
import type { ReactNode } from 'react'
import { formatNewsDate } from './formatNewsDate.ts'
import styles from './NewsMeta.module.css'

export interface NewsMetaProps {
  author?: string
  /** ISO timestamp the article was published. */
  date?: string | null
  readTimeMinutes?: number
  /** "4 min" instead of "4 min read", for cards. */
  compact?: boolean
  className?: string
}

/** The byline line under a story: "Maya Chen · Oct 6 · 5 min read". */
export function NewsMeta({ author, date, readTimeMinutes, compact, className }: NewsMetaProps) {
  const parts: ReactNode[] = []
  if (author) parts.push(<span className={styles.author}>{author}</span>)
  if (date) parts.push(<time dateTime={date}>{formatNewsDate(date)}</time>)
  if (readTimeMinutes) parts.push(<span>{readTimeMinutes} {compact ? 'min' : 'min read'}</span>)
  if (parts.length === 0) return null

  return (
    <span className={[styles.meta, className].filter(Boolean).join(' ')}>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 && <span className={styles.dot} aria-hidden="true">·</span>}
          {part}
        </Fragment>
      ))}
    </span>
  )
}
